import { createFileRoute, Outlet, Navigate } from '@tanstack/react-router'
import { useAuth } from '@/common/hooks/useAuth'
import { ManagerNav } from '@/common/components/manager-nav/ManagerNav'

export const Route = createFileRoute('/manager')({
  component: ManagerLayout,
})

function ManagerLayout() {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh' }}>
        Loading...
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />
  }

  return (
    <div>
      <ManagerNav />
      <main>
        <Outlet />
      </main>
    </div>
  )
}
